<template>
  <div class="results">
    <div v-if="contentType === 'Courses'" class="results__grid">
      <CourseTile
        v-for="item in items"
        :key="item.objectID"
        :course="item"
        :isFreeTrialUser="isFreeTrialUser"
      />
    </div>
    <div v-if="contentType === 'Learning Paths'" class="results__grid">
      <LearningPathTile
        v-for="item in items"
        :key="item.objectID"
        :path="item"
      />
    </div>
    <div v-if="contentType === 'Videos'" class="results__flex-grid">
      <VideoTileResults
        :items="items"
        :parentsSeachResults="parentsSeachResults"
        @open-video="$emit('open-video', $event)"
      />
    </div>
    <div v-if="contentType === 'Bootcamps'" class="results__flex-grid">
      <BootcampTileResults :items="items" />
    </div>
  </div>
</template>

<script>
import CourseTile from '@/components/layout/CourseTile.vue'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'
import BootcampTileResults from '@/components/search/BootcampTileResults.vue'
import VideoTileResults from '@/components/search/VideoTileResults.vue'

export default {
  name: 'TileResults',
  components: {
    CourseTile,
    LearningPathTile,
    BootcampTileResults,
    VideoTileResults,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    parentsSeachResults: {
      type: Object,
      required: false,
    },
  },
  methods: {
    openVideo(video) {
      this.$emit('open-video', video)
    },
  },
}
</script>

<style lang="scss" scoped>
.results {
  &__grid {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 8px;
    }
    @include lg-desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
    }
  }
  &__flex-grid {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
